var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "rbvp-section-content" }, [
    _c("input", {
      ref: "ruleSetFileInput",
      staticClass: "rbvp-hidden-file-input",
      attrs: { type: "file", accept: "application/json,.json" },
      on: { change: _vm.handleRuleSetFileChange },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "rbvp-guide-card" }, [
      _c("div", { staticClass: "rbvp-guide-title" }, [_vm._v("本地规则集")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "rbvp-guide-meta" }, [
        _c("span", [
          _vm._v(
            "当前共 " + _vm._s(_vm.state.ruleSetNames.length) + " 个规则集"
          ),
        ]),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.state.selectedRuleSetName || "未选中规则集")),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "rbvp-section-header" }, [
      _c("div", { staticClass: "rbvp-section-title" }, [_vm._v("本地规则集")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rbvp-section-actions" },
        [
          _c(
            "VButton",
            {
              on: {
                click: function ($event) {
                  return _vm.openRuleSetExport("all")
                },
              },
            },
            [_vm._v("导出全部")]
          ),
          _vm._v(" "),
          _c(
            "VButton",
            {
              attrs: { disabled: !_vm.state.selectedRuleSet },
              on: {
                click: function ($event) {
                  return _vm.openRuleSetExport("current")
                },
              },
            },
            [_vm._v("\n        导出当前\n      ")]
          ),
          _vm._v(" "),
          _c(
            "VButton",
            {
              on: {
                click: function ($event) {
                  return _vm.openRuleSetImport()
                },
              },
            },
            [_vm._v("导入规则集")]
          ),
          _vm._v(" "),
          _c(
            "VButton",
            {
              on: {
                click: function ($event) {
                  return _vm.createRuleSet()
                },
              },
            },
            [_vm._v("新增规则集")]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.state.ruleSetTransferMode
      ? _c(
          "div",
          { staticClass: "rbvp-rule-set-transfer" },
          [
            _c("div", { staticClass: "rbvp-rule-set-transfer-header" }, [
              _c("div", { staticClass: "rbvp-rule-set-transfer-title" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.state.ruleSetTransferMode === "export"
                        ? "导出规则集"
                        : "导入规则集"
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "rbvp-icon-button",
                  attrs: { type: "button", title: "关闭" },
                  on: {
                    click: function ($event) {
                      return _vm.closeRuleSetTransferPanel()
                    },
                  },
                },
                [_c("VIcon", { attrs: { icon: "close", size: 16 } })],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "rbvp-field-hint" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.state.ruleSetTransferMode === "export"
                      ? "已按 JSON 生成导出内容，可直接复制保存。导入时支持整批规则集，也支持仅包含单个规则集的内容。"
                      : "请粘贴 JSON 内容。导入时会按规则集名称合并，同名规则集会被覆盖。"
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("TextArea", {
              staticClass: "rbvp-textarea",
              attrs: {
                text: _vm.state.ruleSetTransferText,
                rows: "10",
                readonly: _vm.state.ruleSetTransferMode === "export",
                placeholder:
                  _vm.state.ruleSetTransferMode === "export"
                    ? "导出内容会显示在这里"
                    : "请粘贴导入的规则集 JSON",
              },
              on: { change: _vm.updateRuleSetTransferText },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rbvp-rule-set-transfer-actions" },
              [
                _vm.state.ruleSetTransferMode === "export"
                  ? _c(
                      "VButton",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.copyRuleSetTransferText()
                          },
                        },
                      },
                      [_vm._v("\n        复制内容\n      ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.state.ruleSetTransferMode === "export"
                  ? _c(
                      "VButton",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.downloadRuleSetExportFile()
                          },
                        },
                      },
                      [_vm._v("\n        下载文件\n      ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.state.ruleSetTransferMode === "import"
                  ? _c(
                      "VButton",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.triggerRuleSetFileImport()
                          },
                        },
                      },
                      [_vm._v("\n        选择文件\n      ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.state.ruleSetTransferMode === "import"
                  ? _c(
                      "VButton",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.applyImportedRuleSets()
                          },
                        },
                      },
                      [_vm._v("\n        导入并覆盖同名项\n      ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "VButton",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.closeRuleSetTransferPanel()
                      },
                    },
                  },
                  [_vm._v("关闭")]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "rbvp-rule-set-layout" }, [
      _c(
        "div",
        { staticClass: "rbvp-rule-set-list" },
        [
          _vm._l(_vm.state.ruleSetNames, function (name) {
            return _c(
              "button",
              {
                key: name,
                staticClass: "rbvp-rule-set-item",
                class: { active: name === _vm.state.selectedRuleSetName },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.selectRuleSet(name)
                  },
                },
              },
              [
                _c("span", { staticClass: "rbvp-rule-set-item-name" }, [
                  _vm._v(_vm._s(name)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "rbvp-rule-set-item-meta" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.state.localRuleSets[name].matcherType) +
                      " ·\n          " +
                      _vm._s(_vm.state.localRuleSets[name].entries.length) +
                      "\n        "
                  ),
                ]),
              ]
            )
          }),
          _vm._v(" "),
          _vm.state.ruleSetNames.length === 0
            ? _c("div", { staticClass: "rbvp-empty-state" }, [
                _c("div", { staticClass: "rbvp-empty-state-title" }, [
                  _vm._v("还没有本地规则集"),
                ]),
                _vm._v(" "),
                _vm._m(1),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.state.selectedRuleSet
        ? _c("div", { staticClass: "rbvp-rule-set-editor" }, [
            _c(
              "label",
              { staticClass: "rbvp-field" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("名称"),
                ]),
                _vm._v(" "),
                _c("TextBox", {
                  attrs: { text: _vm.state.selectedRuleSetNameInput },
                  on: { change: _vm.updateSelectedRuleSetNameInput },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "rbvp-field" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("匹配类型"),
                ]),
                _vm._v(" "),
                _c("VDropdown", {
                  attrs: {
                    value: _vm.state.selectedRuleSet.matcherType,
                    items: _vm.state.matcherTypes,
                    "key-mapper": (item) => item,
                  },
                  on: { change: _vm.updateSelectedRuleSetMatcherType },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "item",
                        fn: function ({ item }) {
                          return [_vm._v(_vm._s(item))]
                        },
                      },
                    ],
                    null,
                    false,
                    1280491791
                  ),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "rbvp-field" },
              [
                _c("span", { staticClass: "rbvp-field-label" }, [
                  _vm._v("条目"),
                ]),
                _vm._v(" "),
                _c("TextArea", {
                  staticClass: "rbvp-textarea",
                  attrs: {
                    text: _vm.state.selectedRuleSetEntries,
                    rows: "10",
                    placeholder:
                      "每行一条规则集条目，例如 UID、标签名、分区名或标题关键字",
                  },
                  on: { change: _vm.updateSelectedRuleSetEntries },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "rbvp-field-hint" }, [
              _vm._v(
                "\n        每行一个匹配条目，保存时会自动去掉空行。重命名不会覆盖现有同名规则集。\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rbvp-rule-set-actions" },
              [
                _c(
                  "VButton",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.saveRuleSet()
                      },
                    },
                  },
                  [_vm._v("保存规则集")]
                ),
                _vm._v(" "),
                _c(
                  "VButton",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.removeRuleSet()
                      },
                    },
                  },
                  [_vm._v("删除规则集")]
                ),
              ],
              1
            ),
          ])
        : _c("div", { staticClass: "rbvp-empty-state rbvp-rule-set-empty" }, [
            _c("div", { staticClass: "rbvp-empty-state-title" }, [
              _vm._v("请选择或创建一个规则集"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "rbvp-empty-state-text" }, [
              _vm._v(
                "\n        左侧用于管理规则集列表，右侧用于编辑名称、匹配类型和条目内容。\n      "
              ),
            ]),
          ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "rbvp-guide-text" }, [
      _vm._v(
        "\n      规则集适合维护可复用的匹配条目，例如某组 UP、分区或标题关键字。主规则中可通过\n      "
      ),
      _c("code", [_vm._v("RULE-SET, 规则集名称")]),
      _vm._v(" 统一引用。\n    "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "rbvp-empty-state-text" }, [
      _vm._v("\n          可以先创建一个规则集，再在主规则中通过 "),
      _c("code", [_vm._v("RULE-SET")]),
      _vm._v(" 引用它。\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }